"use client";

import {
  Content as RadixTabsContent,
  List as RadixTabsList,
  Root as RadixTabsRoot,
  Trigger as RadixTabsTrigger,
  type TabsContentProps as RadixTabsContentProps,
  type TabsListProps as RadixTabsListProps,
  type TabsProps as RadixTabsRootProps,
  type TabsTriggerProps as RadixTabsTriggerProps,
} from "@radix-ui/react-tabs";
import { forwardRef } from "react";

import {
  cardTabsListVariants,
  cardTabsTriggerVariants,
  type CardTabsListVariants,
  type CardTabsTriggerVariants,
} from "./card-tabs.styles";

// -----------------------------------------------------------------------------

export type CardTabsRootRef = React.ComponentRef<typeof RadixTabsRoot>;

export interface CardTabsRootProps extends RadixTabsRootProps {}

export { RadixTabsRoot as CardTabs, RadixTabsRoot as CardTabsRoot };

// -----------------------------------------------------------------------------

export type CardTabsListRef = React.ComponentRef<typeof RadixTabsList>;

export interface CardTabsListProps
  extends RadixTabsListProps, CardTabsListVariants {}

const CardTabsList = forwardRef<CardTabsListRef, CardTabsListProps>(
  ({ children, className, placement, ...props }, ref) => (
    <RadixTabsList
      {...props}
      className={cardTabsListVariants({ className, placement })}
      ref={ref}
    >
      {children}
    </RadixTabsList>
  ),
);

CardTabsList.displayName = "CardTabsList";

export { CardTabsList };

// -----------------------------------------------------------------------------

export type CardTabsTriggerRef = React.ComponentRef<typeof RadixTabsTrigger>;

export interface CardTabsTriggerProps
  extends RadixTabsTriggerProps, CardTabsTriggerVariants {}

const CardTabsTrigger = forwardRef<CardTabsTriggerRef, CardTabsTriggerProps>(
  ({ children, className, ...props }, ref) => (
    <RadixTabsTrigger
      {...props}
      className={cardTabsTriggerVariants({ className })}
      ref={ref}
    >
      {children}
    </RadixTabsTrigger>
  ),
);

CardTabsTrigger.displayName = "CardTabsTrigger";

export { CardTabsTrigger };

// -----------------------------------------------------------------------------

export type CardTabsContentRef = React.ComponentRef<typeof RadixTabsContent>;

export interface CardTabsContentProps extends RadixTabsContentProps {}

const CardTabsContent = forwardRef<CardTabsContentRef, CardTabsContentProps>(
  ({ children, className, ...props }, ref) => (
    <RadixTabsContent {...props} className={className} ref={ref}>
      {children}
    </RadixTabsContent>
  ),
);

CardTabsContent.displayName = "CardTabsContent";

export { CardTabsContent };
